import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const CloudWatchIntegrationsDialog = React.lazy(() => import("./CloudWatchIntegrationsDialog"));

interface CloudWatchIntegrationsDialogLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function CloudWatchIntegrationsDialogLazy(props: CloudWatchIntegrationsDialogLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <CloudWatchIntegrationsDialog {...props} />
    </Suspense>
  );
}
